import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogTitle,
} from "../../../../ui/AlertDialog/AlertDialog";
import { t } from "i18next";
import React, { useContext, useEffect } from "react";
import { useFetch } from "../../../../hooks/useFetch";
import { Button } from "../../../../ui/Button";
import { useNavigate } from "react-router-dom";
import { TriggersContext } from "./Triggers";
import { useAppStore } from "../../../../stores/RootStore";

type Props = {
  id: string;
  isDeleteOpen: boolean;
  closeModal: Function;
  closeEditModal: Function;
};

const DeleteTrigger = ({ id, isDeleteOpen, closeModal, closeEditModal }: Props) => {
  const store = useAppStore()
  const [{ response: deleteResponse, isLoading: deleteIsLoading, error: deleteError }, doFetchItemDelete] = useFetch(
    `/directories/triggers/${id}`
  );

  const { triggers, setTriggers } = useContext(TriggersContext)!;

  const deleteItem = () => {
    let restTriggers = triggers?.filter((trigger) => trigger.id != id)!
    store.setTriggers(restTriggers)
    setTriggers(restTriggers);
  };

  useEffect(() => {
    if (deleteResponse) {
      deleteItem();
      closeEditModal();
      closeModal();
    }
  }, [deleteResponse]);

  const onDelete = () => {
    doFetchItemDelete({
      method: "DELETE",
    });
  };

  const openStateChange = () => {
    if (isDeleteOpen) closeModal();
  };

  return (
    <AlertDialog open={isDeleteOpen} onOpenChange={openStateChange}>
      <AlertDialogContent style={{ maxWidth: 450 }}>
        <AlertDialogTitle>Удалить триггер</AlertDialogTitle>
        <AlertDialogDescription>Вы уверены, что хотите удалить триггер?</AlertDialogDescription>

        <div className="flex justify-between mt-4">
          <Button variant={"destructive"} size={"md"} className="px-3" onClick={onDelete}>
            {t("delete")}
          </Button>
          <AlertDialogCancel className="h-8">{t("cancel")}</AlertDialogCancel>
        </div>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default DeleteTrigger;
